import { INDIA_SUB_PAGES } from "../../Config/Static/ProgramDetail/India";
import DEI1 from "../../assets/images/ameios/dei_1.webp";
import DEI2 from "../../assets/images/ameios/dei_2.webp";
import DEI3 from "../../assets/images/ameios/dei_3.webp";
import DEI4 from "../../assets/images/ameios/dei_4.webp";
import DEI5 from "../../assets/images/ameios/dei_5.webp";
import DEI6 from "../../assets/images/ameios/dei_6.webp";
import DEI7 from "../../assets/images/ameios/dei_7.webp";

import TestimonialMadhumitaGupta from "../../assets/images/india/testimonial_madhumita_gupta.webp";
import TestimonialThilagaDevaraj from "../../assets/images/india/testimonial_thilaga_devaraj.webp";
import TestimonialMeenakshiGupta from "../../assets/images/india/testimonial_meenakshi_gupta.webp";

export const INDIA_DRIVING_TOGETHER = {
  heading: "page.common.driving_together",
  title: "page.common.driving_together_title",
  description: "page.india.driving_together_description",
  href: "https://india.nissanmotornews.com/en-IN/releases/fostering-a-safe-space-for-everyone-nissan-amieo-africa-middle-east-india-europe-oceania-shares-its-first-diversity-equity-and-inclusion-dei-report",
  href_jp:
    "https://india.nissanmotornews.com/en-IN/releases/fostering-a-safe-space-for-everyone-nissan-amieo-africa-middle-east-india-europe-oceania-shares-its-first-diversity-equity-and-inclusion-dei-report",
  src: [DEI1, DEI2, DEI3, DEI4, DEI5, DEI6, DEI7],
  detailed_description: "page.india.driving_together_description_bottom",
  disableLink: true,
};

export const INDIA_JOURNEY = {
  heading: "page.discover.your_journey",
  title: "page.discover.your_journey.title",
  description: "page.discover.your_journey.description",
  items: INDIA_SUB_PAGES,
  sub_description: "page.discover.your_journey_description_bottom",
};

export const INDIA_TESTIMONIALS = [
  {
    id: 1,
    userName: "Madhumita Gupta​",
    userDesignation: "page.testimonial.india_designation_1",
    description: "page.testimonial.india_description_1",
    src: TestimonialMadhumitaGupta,
  },
  {
    id: 2,
    userName: "Thilaga Devaraj​",
    userDesignation: "page.testimonial.india_designation_2",
    description: "page.testimonial.india_description_2",
    src: TestimonialThilagaDevaraj,
  },
  {
    id: 3,
    userName: "Meenakshi Gupta​",
    userDesignation: "page.testimonial.india_designation_3",
    description: "page.testimonial.india_description_3",
    src: TestimonialMeenakshiGupta,
  },
];
